import React from 'react';
import { NavLink } from 'react-router-dom';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Col
} from 'reactstrap';

class Lock extends React.Component {
  componentDidMount() {
    document.body.classList.toggle("lock-page");
  }
  componentWillUnmount() {
    document.body.classList.toggle("lock-page");
  }

  keyPress(e) {
    if (e.keyCode === 13) {
      this.handleSubmit(e)
      // put the login here
    }
  }
  render() {
    return (
      <>
        <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Card className="card-lock card-white text-center">
                <CardHeader>
                  <img alt="..." src={require("../../../assets/img/default-avatar.jpg")} />
                </CardHeader>
                <CardBody>
                  <CardTitle tag="h4">Mike Smith</CardTitle>
                  <InputGroup>
                    <InputGroupText>
                      <i className="tim-icons icon-key-25" />
                    </InputGroupText>
                    <Input placeholder="Password" type="Password" />
                  </InputGroup>
                </CardBody>
                <CardFooter>
                  <NavLink to="/admin/welcome" tag="li">

                    <Button
                      className="btn-round"
                      color="grey"

                      size="lg"
                    >
                      Unlock
                    </Button>
                  </NavLink>
                </CardFooter>
              </Card>
            </Col>
          </Container>
        </div>
      </>
    );
  }
}

export default Lock;
